import { Spinner, Typography } from '@material-tailwind/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TableLayout from '../../../layouts/pagesLayouts/TableLayout'
import { useViewConsumptionDetailPeriodQuery } from '../../../store/auth/authService'
import { useParams } from 'react-router-dom'
import DoughnutGraphController from './DoughnutGraphController'
import { classCharContainerHeight } from '../common'

type ConsByPeriodFormType = {
    contract_id: number,
    periodFrom: string,
    periodTo: string,
}

const ViewByPeriodDetailing = ({
    periodFrom,
    periodTo,
    graphTarifId,
    graphPriceId
}: {
    periodFrom: string,
    periodTo: string,
    graphTarifId: string,
    graphPriceId: string
}) => {
    const { t } = useTranslation()
    const { param_contract_id } = useParams<{
        param_contract_id: string;
    }>()



    const [sendForm, setSendForm] = useState<ConsByPeriodFormType>({
        contract_id: Number(param_contract_id) || 0,
        periodFrom: periodFrom,
        periodTo: periodTo,
    });

    const { currentData, error, isFetching } = useViewConsumptionDetailPeriodQuery<any>(sendForm, {
        skip: !periodFrom || !periodTo,
    })

    useEffect(() => {
        setSendForm({
            contract_id: Number(param_contract_id) || 0,
            periodFrom: periodFrom,
            periodTo: periodTo,
        })
    }, [periodFrom, periodTo]);

    return (
        <div className={`transition-opacity delay-[150ms] duration-[250ms]`}>
            {
                currentData ?
                    Object.keys(currentData)?.length === 0 ?
                        <div className={`flex items-center justify-center ${classCharContainerHeight}`}>
                            <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                                {t('analytics.month_detailing_no_data')}
                            </Typography>
                        </div>
                        :
                        <DoughnutGraphController
                            currentData={currentData}
                            graphTarifId={graphTarifId}
                            graphPriceId={graphPriceId}
                        />
                    :
                    isFetching ?
                        <div className={`${classCharContainerHeight} flex justify-center items-center`}>
                            <Spinner />
                        </div>
                        :
                        error ?
                            <TableLayout>
                                <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                                    {t('tables.error_on_loading')}
                                </Typography>
                            </TableLayout>
                            :
                            <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                                {t('analytics.month_detailing_no_data')}
                            </Typography>
            }
        </div>
    )
}

export default ViewByPeriodDetailing